import React from "react";
import { FormControl, MenuItem, Select } from "@material-ui/core";
import PropTypes from "prop-types";

const StudySelect = ({ studies, selectedValue, onStudyChange }) => {

    return (
        <Select
            onChange={(event) => onStudyChange(event.target.value)}
            margin='dense'
            variant='outlined'
            value={selectedValue}>
            {studies.map((element) => {
                return (
                    <MenuItem key={element.id} value={element.id}>{element.name}</MenuItem>
                )
            })}
            {studies.length < 1 ? <MenuItem disabled={true} value={null}>No Studies found</MenuItem> : null}
        </Select>
    )
}

StudySelect.propTypes = {
    studies: PropTypes.array,
    selectedValue: PropTypes.string,
    onStudyChange: PropTypes.func
}

StudySelect.defaultProps = {
    selectedValue: '',
    studies: []
}

export default StudySelect;
